<div class="
    fusion-fullwidth
    fullwidth-box
    fusion-builder-row-1 fusion-parallax-none
    nonhundred-percent-fullwidth
    non-hundred-percent-height-scrolling
  " style="
    background-color: rgba(255, 255, 255, 0);
    background-image: url('/wp-content/uploads/2015/12/about-call-to-action-57862405-1024x630.jpg');
    background-position: center bottom;
    background-repeat: no-repeat;
    padding-top: 100px;
    padding-right: 30px;
    padding-bottom: 20px;
    padding-left: 30px;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  ">
  <div class="fusion-builder-row fusion-row">
    <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_1
        fusion-builder-column-0
        fusion-one-full
        fusion-column-first
        fusion-column-last
        1_1
      " style="margin-top: 0px; margin-bottom: 0px">
      <div class="fusion-column-wrapper" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
        <style type="text/css">
          @media only screen and (max-width: 800px) {
            .fusion-title.fusion-title-1 {
              margin-top: 10px !important;
              margin-bottom: 10px !important;
            }
          }
        </style>
        <div class="
            fusion-title
            title
            fusion-title-1
            fusion-sep-none
            fusion-title-text
            fusion-title-size-one
          " style="margin-top: 0px; margin-bottom: 10px">
          <h1 class="title-heading-left" style="margin: 0">
            <h1 style="text-align: center">
              <span style="color: #ffffff">{{type === 'SALE' ? 'ANNUNCI DI VENDITA' : 'ANNUNCI DI NOLEGGIO'}}</span>
            </h1>
          </h1>
        </div>
        <div style="color: white; font-weight: 500; text-align: center">

        </div>
        <div class="fusion-clearfix"></div>
      </div>
    </div>
    <form [formGroup]="form" id="form">
      <style type="text/css">
        input::-webkit-input-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-webkit-input-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Firefox < 19 */
        input:-moz-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-moz-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Firefox > 19 */
        input::-moz-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover::-moz-placeholder {
          color: #ffffff;
          transition: none;
        }

        /* Internet Explorer 10 */
        input:-ms-input-placeholder {
          color: #333333;
          text-align: left;
          font-weight: 300;
          font-family: Montserrat, Arial, Helvetica, sans-serif;
        }

        input:hover:-ms-input-placeholder {
          color: #ffffff;
          transition: none;
        }
      </style>
      <div style="
          content: '';
          display: table;
          clear: both;
          width: 100%;
          padding-top: 15px;
        ">
        <div id="form_wrapper" style="display: flex; justify-content: space-around">
          <style type="text/css">
            @media only screen and (max-width: 800px) {
              #form_wrapper {
                flex-wrap: wrap;
              }
            }
          </style>

          <!-- RAGIONE SOCIALE -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 40%;
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-building fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <input style="
                        font-size: 16px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                      " class="ng-app-input" type="text" formControlName="descriptionFilter"
                      placeholder="TITOLO o DESCRIZIONE" />
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
          <!-- LOCALITA' -->
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 29%;
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-map-marker-alt fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <input style="
                        font-size: 16px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                      " class="ng-app-input" type="text" formControlName="provinceFilter" placeholder="PROVINCIA" />
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>
          <div class="
              fusion-layout-column
              fusion_builder_column
              fusion_builder_column_2_5
              fusion-builder-column-2
              fusion-two-fifth
              2_5
            " style="
              margin-top: 0px;
              margin-bottom: 0px;
              width: 29%;
            ">
            <div class="fusion-column-wrapper" style="
                background-color: #ffffff;
                background-position: left top;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                -o-background-size: cover;
                background-size: cover;
                padding-right: 10px;
              " data-bg-url="">
              <ul class="fusion-checklist fusion-checklist-2"
                style="font-size: 16px; line-height: 27.2px; padding: 3px">
                <li class="fusion-li-item">
                  <span style="
                      height: 27.2px;
                      width: 27.2px;
                      margin-right: 11.2px;
                      margin-right: 10px;
                      padding-top: 5px;
                      padding-right: 0;
                      padding-left: 10px;
                    " class="icon-wrapper circle-no"><i class="fusion-li-icon fa-server fas" style="
                        color: #333333;
                        padding-top: 15px;
                        padding-left: 8px;
                      "></i></span>
                  <div class="fusion-li-item-content" style="margin-left: 45px">
                    <select formControlName="categoryFilter" style="
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        font-size: 15px !important;
                        font-weight: 300;
                        letter-spacing: 1px !important;
                        padding-bottom: 0 !important;
                        padding-left: 5px !important;
                        border: none;
                        width: 100%;
                      ">
                      <option [ngValue]="null">TUTTE LE CATEGORIE</option>
                      <option [ngValue]="category.code" *ngFor="let category of categoryList">
                        {{ category.description }}
                      </option>
                    </select>
                  </div>
                </li>
              </ul>
              <div class="fusion-clearfix"></div>
            </div>
          </div>



        </div>
      </div>

      <div style="
          content: '';
          display: table;
          clear: both;
          width: 100%;
          padding-top: 15px;
        ">
      </div>
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_1
          fusion-builder-column-8
          fusion-one-full
          fusion-column-first
          fusion-column-last
          1_1
        " style="margin-top: 0px; margin-bottom: 0px">
        <div class="fusion-column-wrapper" style="
            padding: 30px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            background-size: cover;
            height: auto;
          " data-bg-url="">
          <div class="fusion-sep-clear"></div>
          <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 20px"></div>
          <div class="fusion-button-wrapper fusion-aligncenter">
            <style type="text/css">
              .fusion-button.button-1 {
                border-radius: 0px;
              }
            </style>
            <a (click)="search()" class="
                fusion-button
                button-flat button-xlarge button-default button-1
                fusion-button-default-span fusion-button-default-type
              " target="_self"><span class="fusion-button-text">CERCA</span></a>
          </div>
          <div class="fusion-sep-clear"></div>
          <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="
    fusion-layout-column
    fusion_builder_column
    fusion_builder_column_1_1
    fusion-builder-column-22
    fusion-one-full
    fusion-column-first
    fusion-column-last
    1_1
  " style="margin-top: 0px; margin-bottom: 0px">
  <div class="fusion-column-wrapper" style="
      padding: 0px;
      background-position: left top;
      background-repeat: no-repeat;
      background-size: cover;
      height: auto;
    " data-bg-url="">
    <div class="fusion-sep-clear"></div>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
    <div class="fusion-clearfix"></div>
  </div>
</div>
<!-- CARDS -->
<style type="text/css">
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link),
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):before,
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover,
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:before,
  .fusion-fullwidth.fusion-builder-row-1 a:not(.fusion-button):not(.fusion-builder-module-control):not(.fusion-social-network-icon):not(.fb-icon-element):not(.fusion-countdown-link):not(.fusion-rollover-link):not(.fusion-rollover-gallery):not(.fusion-button-bar):not(.add_to_cart_button):not(.show_details_button):not(.product_type_external):not(.fusion-quick-view):not(.fusion-rollover-title-link):not(.fusion-breadcrumb-link):hover:after {
    color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .pagination a.inactive:hover,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a {
    border-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .pagination .current {
    border-color: #ffa626;
    background-color: #ffa626;
  }

  .fusion-fullwidth.fusion-builder-row-1 .fusion-filters .fusion-filter.fusion-active a,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-date-and-formats .fusion-format-box,
  .fusion-fullwidth.fusion-builder-row-1 .fusion-popover,
  .fusion-fullwidth.fusion-builder-row-1 .tooltip-shortcode {
    color: #ffa626;
  }

  #main .fusion-fullwidth.fusion-builder-row-1 .post .blog-shortcode-post-title a:hover {
    color: #ffa626;
  }
</style>
<div *ngIf="!cards || cards.length === 0" style="text-align: center; margin-top: 8vh; margin-bottom: 8vh">
  <p style="font-size: 2rem">
    <strong>Non ci sono annunci da visualizzare</strong>
  </p>
</div>

<!-- CARD TEMPLATE -->
<div *ngFor="let card of cards">
  <div class="
      fusion-fullwidth
      fullwidth-box
      fusion-builder-row-2
      nonhundred-percent-fullwidth
      non-hundred-percent-height-scrolling
      fusion-equal-height-columns
    " style="
      background-color: rgba(255, 255, 255, 0);
      background-position: center center;
      background-repeat: no-repeat;
      padding-top: 0px;
      padding-right: 30px;
      padding-left: 30px;
      margin-bottom: 30px;
    ">
    <div class="fusion-builder-row fusion-row" style="background-color: var(--ng-app-mid-grey-color)">
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_4
          fusion-builder-column-5
          fusion-one-fourth
          fusion-column-first
          1_4
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 33%;
          width: calc(33% - ((0px) * 0.25));
          margin-right: 0px;
        ">
        <div class="fusion-column-wrapper" style="
            background-color: #efefef;
            padding: 30px 50px 10px 50px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          " data-bg-url="">
          <div height="300" style="display: inline-flex"
            *ngIf="getAttachmentList(card, 'IMAGE') && getAttachmentList(card, 'IMAGE').length > 0">
            <i (click)="decreaseCardImage(card)" class="fusion-li-icon fa-chevron-left fas" style="    position: absolute;
                  top: calc(50% - 30px);
                  left: 7%;color: #333333;font-size: 30px;cursor:pointer;"></i>
            <img id="{{card.announcementId + '_image'}}" (click)="openAttachmentUrl(card.currentImageUrl)"
              src="{{ card.currentImageUrl }}" width="300" class="imageframe-align-center" style="cursor:pointer"
              height="300" class="img-responsive wp-image-1307" />

            <i (click)="increaseCardImage(card)" class="fusion-li-icon fa-chevron-right fas" style="    position: absolute;
                top: calc(50% - 30px);
                right: 7%;color: #333333;font-size: 30px; cursor:pointer;"></i>
          </div>
          <img *ngIf="getAttachmentList(card, 'IMAGE') && getAttachmentList(card, 'IMAGE').length === 0"
            class="imageframe-align-center" loading="lazy"
            src="/wp-content/uploads/2020/02/Skimming-retina-logo-desktop.png" width="186" alt=""
            title="Skimming retina logo desktop" class="img-responsive wp-image-1190" />
          <div class="fusion-sep-clear"></div>
          <div class="fusion-separator fusion-full-width-sep sep-none"
            style="margin-left: auto; margin-right: auto; margin-top: 15px"></div>
          <ul class="fusion-checklist fusion-checklist-3" style="font-size: 16px; line-height: 27.2px"
            *ngIf="getAttachmentList(card, 'DOCS') && getAttachmentList(card, 'DOCS') > 0">
            <li class="fusion-li-item">
              <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                  class="fusion-li-icon fa-images fas" style="color: #333333"></i></span>
              <div class="fusion-li-item-content" style="margin-left: 38.4px">
                <p><strong style="color: #ffa626">Scarica Allegati</strong></p>
              </div>
            </li>
          </ul>
          <div style="
              background-color: var(--ng-app-light-grey-color);
              padding: 10px;
              max-height: 95px;
              overflow: auto;
              margin-bottom: 5px;
            " *ngIf="getAttachmentList(card, 'DOCS') && getAttachmentList(card, 'DOCS').length > 0">
            <div *ngFor="let attachment of getAttachmentList(card, 'DOCS')">
              <div style="display: flex; justify-content: space-between">
                <p style="
                    font-size: 15px;
                    font-weight: 500;
                    margin-bottom: 0px;
                    padding-left: 3px;
                    padding-bottom: 3px;
                  ">
                  {{ attachment.fileName }}
                </p>
                <i (click)="openAttachmentUrl(attachment.documentUrl)" class="fas fa-download fa-sm" style="
                    cursor: pointer;
                    color: var(--ng-app-theme-yellow-color);
                  "></i>
              </div>
            </div>
          </div>
          <ul *ngIf="getAttachmentList(card, 'DOCS') && getAttachmentList(card, 'DOCS').length === 0"
            class="fusion-checklist fusion-checklist-3" style="font-size: 16px; line-height: 27.2px">
            <li class="fusion-li-item">
              <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px" class="icon-wrapper circle-no"><i
                  class="fusion-li-icon fa-images fas" style="color: #333333"></i></span>
              <div class="fusion-li-item-content" style="margin-left: 38.4px">
                <p style="color: var(--ng-app-dark-grey-color)">
                  <strong>Nessun allegato disponibile</strong>
                </p>
              </div>
            </li>
          </ul>
          <div class="fusion-clearfix"></div>
        </div>
      </div>
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_3_4
          fusion-builder-column-6
          fusion-three-fourth
          fusion-column-last
          3_4
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 67%;
          width: calc(67% - ((0px) * 0.75));
        ">

        <div class="fusion-column-wrapper" style="
            background-color: #efefef;
            padding: 30px 30px 0px 30px;
            min-height: 300px !important;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          " data-bg-url="">

          <div class="fusion-text">
            <div style="display: flex; justify-content: space-between">
              <p>
                <strong>{{ card.title | uppercase}}</strong>
              </p>
              <p style="
                  background: #ffa626;
                  color: white;
                  padding: 5px;
                  font-size: 18px;
                  font-weight: 500;
                  font-weight: bold;
                ">
                {{ card.categoryName | uppercase}}
              </p>
            </div>
            <h5>
              <i>Pubblicato il {{card.publishingDate}}</i><br />
              <br />
            </h5>

            <h5>
              <strong>Descrizione</strong><br />{{ card.description }}<br /> <br />
            </h5>
            <h5>
              <strong>Area: </strong>{{ getProvincesAsString(card) }}<br />
            </h5>
            <h5>
              <strong>Quantità: </strong>{{ card.amount + ' ' + card.unitOfMeasureName}} <br />
            </h5>
            <h5 *ngIf="type === 'RENTAL'">
              <strong>Periodo di disponibilità: </strong>{{ card.startDate | date:'dd/MM/yyyy' }}-{{ card.endDate |
              date:'dd/MM/yyyy' }} <br />
            </h5>
            <h5>
              <strong>Prezzo unitario richiesto: </strong>{{ card.unitPrice | currency: "EUR":"":"0.2-2":"it-IT"
              }}&euro;<br />
            </h5>
          </div>
        </div>
        <div>
          <style type="text/css">
            @media only screen and (max-width: 800px) {
              .ng-ongoing-card-button {
                margin-top: 10px !important;
              }
            }
          </style>
          <div class="
              fusion-button-wrapper fusion-alignright
              ng-ongoing-card-button
            " style="padding: 0 30px 30px 0px;">
            <style type="text/css">
              .fusion-button.button-2 {
                border-radius: 0px;
              }
            </style>
            <a *ngIf="!getOffer(card)" (click)="makeOffer(card)" class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-2
                fusion-button-default-span fusion-button-default-type
              " target="_self"><span class="fusion-button-text">FAI UN'OFFERTA</span></a>
            <div class="proposal-in-progress" *ngIf="getOffer(card)" style="text-align: center;">
              <a class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-2
                fusion-button-default-span fusion-button-default-type
              " target="_self"><span class="fusion-button-text">LA TUA OFFERTA E' IN VALUTAZIONE</span></a>
              <div class="proposal-box">
                <b>Quantità richiesta:</b> {{ getOffer(card).amount}}<br />
                <b>Importo offerto:</b> {{getOffer(card).unitPrice | currency: "EUR":"":"0.2-2":"it-IT"}}€ <br />
                <div *ngIf="type === 'RENTAL'">
                  <b>Periodo di noleggio:</b> {{getOffer(card).startDate | date:'dd/MM/yyyy'}}-{{getOffer(card).endDate
                  | date:'dd/MM/yyyy'}}<br />
                  <b>Durata richiesta:</b> {{getOffer(card).timeUnitAmount}} {{getOffer(card).timeUnitType}}<br />
                </div>
                <style>
                  .proposal-in-progress:hover .proposal-box {
                    display: block;
                  }

                  .proposal-box {
                    min-width: 200px;
                    font-size: 14px;
                    padding: 5px;
                    background: white;
                    border: 0.5px solid silver;
                    position: absolute;
                    text-align: left;
                    display: none;
                  }
                </style>
              </div>
              <br />
              <span style="font-size: 10px">Riceverai una mail non appena la decisione verrà presa.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="offer-modal" [ngStyle]="{ display: displayOffer }" class="fusion-modal modal fade modal-1 modal-invite in"
    tabindex="-1" role="dialog">
    <style type="text/css">
      .modal-1 .modal-header,
      .modal-1 .modal-footer {
        border-color: #ebebeb;
      }
    </style>

    <div class="modal-dialog modal-lg">
      <div class="modal-content fusion-modal-content" style="background-color: #f5f5f5">
        <div class="modal-header">
          <button class="close" type="button" (click)="changeModal()">×</button>
          <h3 class="modal-title fusion-responsive-typography-calculated" id="modal-heading-1" data-fontsize="28"
            data-lineheight="40.6px" style="--fontSize: 28; line-height: 1.45">
            COMPILAZIONE OFFERTA PER L'ANNUNCIO<br />
            <b>{{selectedAnnouncement.title}}</b>
          </h3>
        </div>
        <form [formGroup]="offerForm" (ngSubmit)="onOfferSubmit()">
          <div class="modal-body fusion-clearfix">
            <div>
              <div class="
                fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-11
                  fusion-one-half
                  fusion-column-first
                  1_2
              " style="
                margin-top: 0px;
                margin-bottom: 0px;
                width: 48%;
                margin-right: 4%;">
                <div class="fusion-column-wrapper fusion-column-wrapper-5" style="
                  background-position: left top;
                  background-repeat: no-repeat;
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                " data-bg-url="">
                  <div class="fusion-li-item-content" style="font-size: 16px">
                    Q.TA'* - (Disponibilità: {{selectedAnnouncement.amount + " " +
                    selectedAnnouncement.unitOfMeasureName}})
                  </div>
                </div>

                <input class="ng-app-input" type="number" formControlName="amount" #amountId
                  onchange="this.value = parseFloat(Math.abs(this.value)).toFixed(2); this.value > 0 ? this.value = this.value : this.value = null"
                  min="1" />

              </div>
              <div class="
                fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_2_2
                  fusion-builder-nested-column-11
                  fusion-one-half
                  fusion-column-last
                  2_2
               " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 48%;">
                <div class="fusion-column-wrapper fusion-column-wrapper-5" style="
                  background-position: left top;
                  background-repeat: no-repeat;
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                " data-bg-url="">
                  <div class="fusion-li-item-content" style="font-size: 16px">
                    OFFERTA/UNITA'* - (Proposto: {{selectedAnnouncement.unitPrice | currency: "EUR":"":"0.2-2":"it-IT"
                    }} €)
                  </div>
                </div>
                <div class="fusion-button-wrapper fusion-align-block">
                  <input class="ng-app-input" type="number" formControlName="unitPrice" #unitPriceId oninput="this.value = 
                  !!this.value && Math.abs(this.value) >= 1 ? Math.abs(this.value) : null" min="1" />
                </div>
              </div>
            </div>

            <div *ngIf="type === 'RENTAL'">
              <div class="fusion-sep-clear"></div>
              <div class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 0px"></div>
              <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
                <div class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-11
                  fusion-one-half
                  fusion-column-first
                  1_2
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((4%) * 0.5));
                  margin-right: 4%;
                ">
                  <div class="fusion-column-wrapper fusion-column-wrapper-11" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  " data-bg-url="">
                    <ul class="fusion-checklist fusion-checklist-9" style="font-size: 16px; line-height: 27.2px">
                      <li class="fusion-li-item">
                        <div class="fusion-li-item-content">
                          <p>INIZIO NOLEGGIO* (Disp. dal {{selectedAnnouncement.startDate | date:'dd/MM/yyyy'}})</p>
                        </div>
                      </li>
                    </ul>
                    <div class="fusion-button-wrapper fusion-align-block">
                      <style type="text/css">
                        .fusion-button.button-8 .fusion-button-text,
                        .fusion-button.button-8 i {
                          color: #c4c4c4;
                        }

                        .fusion-button.button-8 .fusion-button-icon-divider {
                          border-color: #c4c4c4;
                        }

                        .fusion-button.button-8:hover .fusion-button-text,
                        .fusion-button.button-8:hover i,
                        .fusion-button.button-8:focus .fusion-button-text,
                        .fusion-button.button-8:focus i,
                        .fusion-button.button-8:active .fusion-button-text,
                        .fusion-button.button-8:active {
                          color: #ffffff;
                        }

                        .fusion-button.button-8:hover .fusion-button-icon-divider,
                        .fusion-button.button-8:hover .fusion-button-icon-divider,
                        .fusion-button.button-8:active .fusion-button-icon-divider {
                          border-color: #ffffff;
                        }

                        .fusion-button.button-8:hover,
                        .fusion-button.button-8:focus,
                        .fusion-button.button-8:active {
                          border-color: #ffffff;
                        }

                        .fusion-button.button-8 {
                          border-color: #333333;
                          border-radius: 0px;
                        }

                        .fusion-button.button-8 {
                          background: #fbfbfb;
                        }

                        .fusion-button.button-8:hover,
                        .button-8:focus,
                        .fusion-button.button-8:active {
                          background: #fbfbfb;
                        }
                      </style>
                      <div class="fusion-button button-flat fusion-button-default-size button-custom button-9 fusion-button-span-yes fusion-button-default-type {{
                        startDateAlert
                      }}">
                        <span class="fusion-button-icon-divider button-icon-divider-left"
                          (click)="startDatePicker.open()"><i class="fa-calendar-alt fas"
                            style="color: #c4c4c4 !important"></i></span>
                        <input matInput [matDatepicker]="startDatePicker" placeholder="Data inizio"
                          formControlName="startDate" id="startDate" #startDateId style="
                          border-bottom: none !important;
                          padding-left: 30px !important;
                          padding-bottom: 3px !important;
                          padding-top: 3px !important;
                        " />
                        <mat-datepicker #startDatePicker></mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-12
                  fusion-one-half
                  fusion-column-last
                  1_2
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((4%) * 0.5));
                ">
                  <div class="fusion-column-wrapper fusion-column-wrapper-12" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  " data-bg-url="">
                    <ul class="fusion-checklist fusion-checklist-10" style="font-size: 16px; line-height: 27.2px">
                      <li class="fusion-li-item">
                        <div class="fusion-li-item-content">
                          <p>FINE NOLEGGIO* (Disp. fino al {{selectedAnnouncement.endDate | date:'dd/MM/yyyy'}})</p>
                        </div>
                      </li>
                    </ul>
                    <div class="fusion-button-wrapper fusion-align-block">
                      <style type="text/css">
                        .fusion-button.button-9 .fusion-button-text,
                        .fusion-button.button-9 i {
                          color: #c4c4c4;
                        }

                        .fusion-button.button-9 .fusion-button-icon-divider {
                          border-color: #c4c4c4;
                        }

                        .fusion-button.button-9:hover .fusion-button-text,
                        .fusion-button.button-9:hover i,
                        .fusion-button.button-9:focus .fusion-button-text,
                        .fusion-button.button-9:focus i,
                        .fusion-button.button-9:active .fusion-button-text,
                        .fusion-button.button-9:active {
                          color: #fbfbfb;
                        }

                        .fusion-button.button-9:hover .fusion-button-icon-divider,
                        .fusion-button.button-9:hover .fusion-button-icon-divider,
                        .fusion-button.button-9:active .fusion-button-icon-divider {
                          border-color: #fbfbfb;
                        }

                        .fusion-button.button-9:hover,
                        .fusion-button.button-9:focus,
                        .fusion-button.button-9:active {
                          border-color: #fbfbfb;
                        }

                        .fusion-button.button-9 {
                          border-color: #333333;
                          border-radius: 0px;
                        }

                        .fusion-button.button-9 {
                          background: #fbfbfb;
                        }

                        .fusion-button.button-9:hover,
                        .button-9:focus,
                        .fusion-button.button-9:active {
                          background: #fbfbfb;
                        }
                      </style>
                      <div class="fusion-button button-flat fusion-button-default-size button-custom button-9 fusion-button-span-yes fusion-button-default-type {{
                        endDateAlert
                      }}">
                        <span class="fusion-button-icon-divider button-icon-divider-left"
                          (click)="endDatePicker.open()"><i class="fa-calendar-alt fas"
                            style="color: #c4c4c4 !important"></i></span>
                        <input matInput [matDatepicker]="endDatePicker" placeholder="Data fine"
                          formControlName="endDate" id="endDate" #endDateId style="
                          border-bottom: none !important;
                          padding-left: 30px !important;
                          padding-bottom: 3px !important;
                          padding-top: 3px !important;
                        " />
                        <mat-datepicker #endDatePicker></mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div [hidden]="type === 'SALE'">
              <div class="fusion-sep-clear"></div>
              <div class="fusion-separator fusion-full-width-sep sep-none"
                style="margin-left: auto; margin-right: auto; margin-top: 10px"></div>
              <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
                <div class="
                  fusion-layout-column
                    fusion_builder_column
                    fusion_builder_column_1_2
                    fusion-builder-nested-column-11
                    fusion-one-half
                    fusion-column-first
                    1_2
                 " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 48%;
                  margin-right: 4%;">
                  <div class="fusion-column-wrapper fusion-column-wrapper-5" style="
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  " data-bg-url="">
                    <div class="fusion-li-item-content" style="font-size: 16px">
                      DURATA*
                    </div>
                  </div>
                  <div class="fusion-button-wrapper fusion-align-block">
                    <input #timeUnitAmountId class="ng-app-input" type="number" formControlName="timeUnitAmount"
                      onchange="this.value = parseFloat(Math.abs(this.value)).toFixed(2); this.value > 0 ? this.value = this.value : this.value = null"
                      min="1" />
                  </div>

                </div>
                <div class="
                  fusion-layout-column
                    fusion_builder_column
                    fusion_builder_column_2_2
                    fusion-builder-nested-column-11
                    fusion-one-half
                    fusion-column-last
                    2_2
                 " style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 48%;">
                  <div class="fusion-column-wrapper fusion-column-wrapper-5" style="
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  " data-bg-url="">
                    <div class="fusion-li-item-content" style="font-size: 16px">
                      UNITA' TEMPORALE* - (ore, gg, sett, mesi)
                    </div>
                  </div>
                  <div class="fusion-button-wrapper fusion-align-block">
                    <input #timeUnitTypeId class="ng-app-input" type="text" formControlName="timeUnitType" />
                  </div>
                </div>
              </div>
            </div>
            <div class="fusion-sep-clear"></div>
            <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
              <div class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion-builder-nested-column-11
                  fusion-one-full
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 100%;
                ">
                <div class="fusion-column-wrapper fusion-column-wrapper-11" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  " data-bg-url="">
                  <ul class="fusion-checklist fusion-checklist-1" style="font-size: 16px; line-height: 27.2px">
                    <li class="fusion-li-item">
                      <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa-address-card fas"
                          style="color: #333333"></i></span>
                      <div class="fusion-li-item-content" style="margin-left: 38.4px">
                        <p>DESCRIZIONE DELLA PROPOSTA</p>
                      </div>
                    </li>
                  </ul>
                  <div class="fusion-button-wrapper fusion-align-block"
                    style="padding: 10px; margin: 10px; border: 2px solid white; font-weight: bold;">
                    Stai offrendo {{unitPriceId.value | currency:
                    "EUR":"":"0.2-2":"it-IT"}}€/{{selectedAnnouncement.unitOfMeasureName}}
                    per {{type === 'SALE' ? " l'acquisto " : " l'affitto "}}
                    di {{amountId.value}} {{selectedAnnouncement.unitOfMeasureName}} di
                    {{selectedAnnouncement.categoryName}}
                    {{type === 'SALE' ? "" : " per una durata di " + timeUnitAmountId.value + " " +
                    timeUnitTypeId.value}}
                    {{type === 'SALE' ? "" : ", da usufruire nel periodo richiesto."}}
                    <br />
                    L'importo totale dell'operazione è di
                    {{unitPriceId.value * amountId.value * timeUnitAmountId.value | currency: "EUR":"":"0.2-2":"it-IT"
                    }}€
                  </div>
                </div>
              </div>
            </div>


            <div class="fusion-sep-clear"></div>
            <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
              <div class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-11
                  fusion-one-half
                  fusion-column-first
                  1_2
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((4%) * 0.5));
                  margin-right: 4%;
                ">
                <div class="fusion-column-wrapper fusion-column-wrapper-11" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  " data-bg-url="">
                  <ul class="fusion-checklist fusion-checklist-1" style="font-size: 16px; line-height: 27.2px">
                    <li class="fusion-li-item">
                      <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa-address-card fas"
                          style="color: #333333"></i></span>
                      <div class="fusion-li-item-content" style="margin-left: 38.4px">
                        <p>NOME* (NP)</p>
                      </div>
                    </li>
                  </ul>
                  <div class="fusion-button-wrapper fusion-align-block">
                    <input type="text" formControlName="contactName" id="contactName" />

                  </div>
                  <div class="fusion-sep-clear"></div>
                  <div class="fusion-separator fusion-full-width-sep sep-none"
                    style="margin-left: auto; margin-right: auto; margin-top: 0px"></div>
                  <ul class="fusion-checklist fusion-checklist-2" style="font-size: 16px; line-height: 27.2px">
                    <li class="fusion-li-item">
                      <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa fa-envelope"
                          style="color: #333333"></i></span>
                      <div class="fusion-li-item-content" style="margin-left: 38.4px">
                        <p>EMAIL* (NP)</p>
                      </div>
                    </li>
                  </ul>
                  <div class="fusion-button-wrapper fusion-align-block">
                    <input type="email" formControlName="contactEmail" id="contactEmail" />
                    <div [ngStyle]="{
                      visibility:
                      offerForm.get('contactEmail').valid ||
                      offerForm.get('contactEmail').pristine
                          ? 'hidden'
                          : 'visible'
                    }" class="ng-alert">
                      Inserire un'email valida.
                    </div>
                  </div>
                </div>
              </div>
              <div class="
                  fusion-layout-column
                  fusion_builder_column
                  fusion_builder_column_1_2
                  fusion-builder-nested-column-12
                  fusion-one-half
                  fusion-column-last
                  1_2
                " style="
                  margin-top: 0px;
                  margin-bottom: 0px;
                  width: 50%;
                  width: calc(50% - ((4%) * 0.5));
                ">
                <div class="fusion-column-wrapper fusion-column-wrapper-12" style="
                    padding: 0px 0px 0px 0px;
                    background-position: left top;
                    background-repeat: no-repeat;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    background-size: cover;
                  " data-bg-url="">
                  <ul class="fusion-checklist fusion-checklist-4" style="font-size: 16px; line-height: 27.2px">
                    <li class="fusion-li-item">
                      <span style="height: 27.2px; width: 27.2px; margin-right: 11.2px"
                        class="icon-wrapper circle-no"><i class="fusion-li-icon fa fa-phone"
                          style="color: #333333"></i></span>
                      <div class="fusion-li-item-content" style="margin-left: 38.4px">
                        <p>TELEFONO* (NP)</p>
                      </div>
                    </li>
                  </ul>
                  <div class="fusion-button-wrapper fusion-align-block">
                    <input type="text" formControlName="contactPhone" id="contactPhone" />
                  </div>
                  <ul class="fusion-checklist fusion-checklist-4" style="font-size: 16px; line-height: 27.2px">
                    <li class="fusion-li-item">
                      <div class="fusion-li-item-content" style="margin-left: 38.4px">
                        <p></p>
                      </div>
                    </li>
                  </ul>
                  <div class="fusion-button-wrapper fusion-align-block">
                  </div>
                </div>
              </div>
            </div>
            <div [ngStyle]="{ visibility: error === 'no_error' ? 'hidden' : 'visible' }" class="ng-alert">
              {{ error }}
            </div>
            <div class="modal-footer">
              <button type="submit" style="border: 0" class="
              fusion-button
              button-default button-medium button
              default
              medium
            ">
                INVIA OFFERTA
              </button>
            </div>
            <div class="ng-spinner">
              <img *ngIf="loading" src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="fusion-builder-row fusion-row" *ngIf="showMore">
  <div class="fusion-text">
    <p style="text-align: right; padding-top: 25px; margin-bottom: 25px">
      <a style="font-weight: 600; cursor: pointer" (click)="loadMoreCards()" target="_self">ALTRI ANNUNCI
        &gt;</a>
    </p>
  </div>
</div>
<app-modal #denialModal>
  <ng-template #header>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 30px"></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>Per usufruire della funzionalità di creazione e pubblicazione di annunci deve avere eseguito almeno una
        transazione (acquisto abbonamento o singola gara) per creare o per partecipare alle gare su SKIMMING</h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 100%;
        ">
      </div>
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-22
          fusion-one-fourth
          fusion-column-last
          1_2
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 100%;
          width: calc(100% - ((1%) * 0.5));
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-left: 4%;
          " data-bg-url="">
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a (click)="denialModal.close()" class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              " target="_self"><span class="fusion-button-text fusion-button-text-left">OK</span></a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>
<app-modal #unauthorizedModal>
  <ng-template #header>
    <div class="fusion-separator fusion-full-width-sep sep-none"
      style="margin-left: auto; margin-right: auto; margin-top: 100px"></div>
    <div class="fusion-text">
      <h3 style="text-align: center">ATTENZIONE</h3>
    </div>
  </ng-template>
  <ng-template #body>
    <div class="fusion-text">
      <h5>{{ "Per accedere a quest area è necessario compilare tutti i dati del profilo azienda all'interno dell'area
        riservata" | uppercase }}</h5>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
      <div class="
          fusion-layout-column
          fusion_builder_column
          fusion_builder_column_1_2
          fusion-builder-nested-column-21
          fusion-one-fourth
          fusion-column-last
          1_2
        " style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 100%;
          width: calc(100% - ((1%) * 0.5));
        ">
        <div class="fusion-column-wrapper fusion-column-wrapper-22" style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            margin-right: 4%;
          " data-bg-url="">
          <div class="fusion-button-wrapper fusion-align-block">
            <style type="text/css">
              .fusion-button.button-10 {
                border-radius: 0px;
              }
            </style>
            <a (click)="unauthorizedModalSubmit()" class="
                fusion-button
                button-flat
                fusion-button-default-size
                button-default button-10
                fusion-button-span-yes fusion-button-default-type
              " target="_self"><span class="fusion-button-text fusion-button-text-left">{{
                "APRI LA PAGINA DI PROFILO"
                }}</span></a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</app-modal>